import { BookingComponent } from "./booking/booking.component";

export const containers: any[] = [
    BookingComponent
];

export { BookingComponent } from './booking/booking.component';
